import http from '@/services/http'
import data from '@/services/data'

export default {
  async loadList () {
    let request
    try {
      request = await data.get('/competitions/list.json')
    } catch (error) {
      request = http.get('/competitions/list')
    }
    return request
  },
  async loadDetails (competitionId) {
    let request
    try {
      request = await data.get(`/competitions/${competitionId}/details.json`)
    } catch (error) {
      request = http.get(`/competitions/${competitionId}/details`)
    }
    return request
  },
  async loadPreview (competitionId, updatedAt) {
    return http.post(`/preview/${competitionId}/${updatedAt}`)
  },
  async loadTermsAndConditions (competitionId) {
    let request
    try {
      request = await data.get(`/competitions/${competitionId}/terms-and-conditions.json`)
    } catch (error) {
      request = http.get(`/competitions/${competitionId}/terms-and-conditions`)
    }
    return request
  }
}
